angular.module('mtic.components.modules.c3').
directive('c3RunLikeMathModuleOperation', function (
  $log,
  $timeout,
  TIMING_CONSTANTS,
  EventManager,
  C3_META_ASSET_URL,
  C3_ASSET_URL,
  PIXI,
  language,
  MODULE_AVAILABLE_LANGUAGE,
  MapStateService,
  userAccount,
  preliveCheck,
  DEV_VARIABLES,
  runLikeMathItemFactory,
  TeacherDataService,
  PlatformService
) {

  return {
    templateUrl: 'template.html',
    scope: {
      moduleMapData: "=moduleMapData",
      interceptClick: "=?",
      slugs:"=?"

    },
    link: function (scope) {
      var thiz = this;
      var items = [];
      var eventManager = new EventManager('c3RunLikeMathModuleOperation',scope);
      //PIXI Rendering Settings
      var canvas_el = document.getElementById("canvas");
      var width = Math.max(1200,canvas_el.parentElement.parentElement.clientWidth);
      var height = Math.max(800,canvas_el.parentElement.parentElement.clientHeight);

      var renderer = PIXI.autoDetectRenderer(width, height, {
        autoResize: true,
        backgroundColor: 0x18052b,
        view: document.getElementById('canvas')
      });
      var stage = new PIXI.Container();
      // stage.alpha = 0.01;

      var canvasDimention = {
        width: canvas_el.parentElement.parentElement.parentElement.clientWidth,
        height: canvas_el.parentElement.parentElement.parentElement.clientHeight,
      }

      stage.y += 100;
      stage.x -= 50;
      // if(TeacherDataService.isTeacherWorkspaceView && window.screen.width < 1200){
      //   stage.x -= 50;
      //   stage.scale.set(0.6,0.6)
      // }else if(TeacherDataService.isTeacherWorkspaceView && window.screen.width < 1400){
      //   //stage.scale.set(0.8,0.8)
      // }

      scope.$watch("moduleMapData", function (moduleMapData) {
        if (!moduleMapData) {
          return;
        }

        //this is what runs to initialize the map
        if (!PIXI_Load_Cache || !PIXI.loader.resources[C3_META_ASSET_URL + "bkg.png"]) {
          PIXI.loader.reset();
          PIXI.loader
          .add([
            C3_ASSET_URL + "lockedLevel.png",
            C3_ASSET_URL + "numpadBtn_orange.png",
            C3_ASSET_URL + "backBtn.png",
            C3_ASSET_URL + "star.png",
            C3_ASSET_URL + "stars.png",
            C3_META_ASSET_URL + "bkg.png"
          ])
          .load(function () {
            PIXI_Load_Cache = true;
            $timeout(()=>{
              init(moduleMapData.resources);
            })
          })
        } else {
          $timeout(()=>{
            init(moduleMapData.resources);
          })
        }
      });


      var getPositioningParams = function(background,totalResource){
        var maxWidth = background.width;
        var paddingSpace = 600;
        var resourceSprite = new PIXI.Sprite(
          PIXI.loader.resources[C3_ASSET_URL + "numpadBtn_orange.png"].texture
        );
        resourceSprite.width = 90;
        resourceSprite.height = 80;


        var itemsPerRow =(maxWidth - paddingSpace)/(resourceSprite.width+25);
        var maxItemsPerRow = Math.min(itemsPerRow,5);
        var columns = Math.ceil(totalResource/maxItemsPerRow);

        return {
          maxPerRow: Math.floor(maxItemsPerRow),
          columns: columns,
          width:90,
          height:80,
          paddingBetweenItem:50,
          paddingLeft:paddingSpace/2,
          paddingTop:paddingSpace/2
        }
      }

      var setupHeadingText = function(positioningParams){
        var headingSprite = new PIXI.Sprite();
        var graphics = new PIXI.Graphics();

        var setupText = function(){
          var subModuleName = language.get(scope.moduleMapData.slug);
          headingSprite.removeChild(graphics);
          graphics.clear();
          graphics.removeChildren();
          graphics =  new PIXI.Graphics();
          var textInfo = new PIXI.Text(subModuleName);
          textInfo.style.align = "center";
          textInfo.style.fill = "white";
          textInfo.style.fontFamily = "vanilla-extract-edit";
          textInfo.style.fontSize = 70;
          var totalLessonsWidth = ((5*positioningParams.width)+(positioningParams.paddingBetweenItem*4));
          graphics.position.set(positioningParams.paddingLeft+(totalLessonsWidth-textInfo.width)/2,100);
          graphics.addChild(textInfo);
          headingSprite.addChild(graphics);
        }
        setupText();
        eventManager.listen('language:change', function() {
          setupText();
        });
        stage.addChild(headingSprite);
      }

      var init = function (moduleMapData) {
        $log.debug('[[c3Module34]] INIT', moduleMapData)
        var combinedResourceMap = {};
        _.forEach(moduleMapData, function (someItem) {
          combinedResourceMap[someItem.slug] = someItem;
        });
        if (Object.keys(combinedResourceMap).length !== moduleMapData.length) {
          throw "some resourceMap slugs are not unique!"
        }

        var positioningParams = getPositioningParams(renderer,Object.keys(combinedResourceMap).length);
        setupHeadingText(positioningParams);
        var count =0;
        _.each(scope.slugs, function (slug) {
          var resource = _.find(scope.moduleMapData.children,function(mapItem){
            return mapItem.slug === slug;
          });
          var displayItem = new runLikeMathItemFactory.createMapItem(resource,scope.onItemClick,positioningParams,count,stage);
          items.push(displayItem);
          //add empty star
          var starTexture = getIconTexture(0,displayItem.sprite);
          displayItem.icon = starTexture;
          stage.addChild(displayItem.sprite);
          displayItem.setupText(count,displayItem.sprite);
          stage.addChild(displayItem.icon);
          count++;
        });

        //renderer.render(stage);
        eventManager.broadcast('teacherStudentWorkspace:studentFilter:request');
        window.addEventListener("resize", onResize);

        $timeout(function(){
          onResize();
          // stage.alpha = 1;
          scope.loading_done = true;
        }, 1000);

      };

      var updateItemInfoComplete = function(existsItem,item_info){
        var exists_score_max = item_info.resourceState ? item_info.resourceState.score_max : null;
        item_info.complete = existsItem.completed;
        item_info.resourceState = {complete:existsItem.completed};
        item_info.resourceState.score_max =  exists_score_max ? Math.max(exists_score_max, existsItem.score) : existsItem.score;
        item_info.score = item_info.resourceState.score_max;
      }

      var starsSprite = PIXI.BaseTexture.fromImage(C3_ASSET_URL + "stars.png");
      var getIconTexture = function(count,subModuleSprite){
        var starIcon;
        var spriteTexture ;
        if(count>=0)
        {
          spriteTexture = new PIXI.Texture(starsSprite, new PIXI.Rectangle(count*90, 0, 90,49));
          starIcon = new PIXI.Sprite(spriteTexture);
          starIcon.width = starIcon.width * 1.16;
          starIcon.height = starIcon.height * 1.16;
          starIcon.position.x = subModuleSprite.position.x-5;
          starIcon.position.y = subModuleSprite.position.y - starIcon.height/2;//-(subModuleSprite.height/2);
        }

        return starIcon;
      }

      var getStars = function(item_info){
        var levelData = {starsAchieved:0};
        var score = item_info.resourceState.score_max;
        if (score >= 1)
        {
            levelData.starsAchieved = 3;
            levelData.badged = true;
        }
        else if (score >= 0.75) {  levelData.starsAchieved = 3;}
        else if (score >= 0.5)  {  levelData.starsAchieved = 2;}
        else if (score >= 0.25) {  levelData.starsAchieved = 1;}

        return levelData;
      }

      function updateMapItems(filteredList,selectedStudent){
        var existsItem = {};
        var containsAtleastOneFilter= false;
        var count = 0;
        var completedItems = {};

        angular.forEach(items,function(each){
          var doneItemsList = [];
          if(filteredList  && filteredList.length>0){
            doneItemsList = _.filter(filteredList,function(item){
              return item.resource_id === each.resource_info.id
            });
          }

          each.clearText();
          if (each.icon){
            each.icon.destroy();
          }

          each.icon = new PIXI.Sprite();

          if(doneItemsList.length > 0){
            _.each(doneItemsList, function(existsItem){
              if(existsItem && existsItem.completed ){
                completedItems[count] = true;
                updateItemInfoComplete(existsItem,each.resource_info);
                var stars = getStars(each.resource_info);
                if((stars && stars.starsAchieved>0)||!selectedStudent){
                  var starTexture = getIconTexture(stars.starsAchieved,each.sprite);
                  each.icon = starTexture;
                }
                if(!selectedStudent || (stars && stars.starsAchieved>0)){
                  var texture = PIXI.loader.resources[C3_ASSET_URL + "numpadBtn_orange.png"].texture;
                  each.sprite.texture = new PIXI.Texture(texture, new PIXI.Rectangle(0, 110, 135,100));//PIXI.loader.resources[C3_ASSET_URL + "lockedLevel.png"].texture;
                  each.updateText(count+1);
                }
              }
            })
          }
          else{
            // var height
            if(selectedStudent && count !== 0){
              each.sprite.texture = PIXI.loader.resources[C3_ASSET_URL + "lockedLevel.png"].texture;
              each.icon = null;
            }
            else{
              each.icon = getIconTexture(0,each.sprite);
              var buttonTexture = PIXI.loader.resources[C3_ASSET_URL + "numpadBtn_orange.png"].texture;
              each.sprite.texture = new PIXI.Texture(buttonTexture, new PIXI.Rectangle(0, 110, 135,100));//PIXI.loader.resources[C3_ASSET_URL + "lockedLevel.png"].texture;
              each.updateText(count+1);
            }
            // stage.addChild(each.sprite);
          }

          if (each.icon){
            stage.addChild(each.icon);
          }
          renderer.render(stage);
          count++;
        });

        // always fill the next one with empty stars
        if(selectedStudent){
          for (var i=0; i<items.length-1; i++){
            var index = i+1;
            if (completedItems[i] && !completedItems[index]){
              var starTexture = getIconTexture(0,items[index].sprite);
              items[index].icon = starTexture;
              var buttonTexture = PIXI.loader.resources[C3_ASSET_URL + "numpadBtn_orange.png"].texture;
              items[index].sprite.texture = new PIXI.Texture(buttonTexture, new PIXI.Rectangle(0, 110, 135,100));//PIXI.loader.resources[C3_ASSET_URL + "lockedLevel.png"].texture;
              items[index].updateText(index+1);
              stage.addChild(items[index].icon);
            }
          }
          renderer.render(stage);
        }
      }

      eventManager.listen("teacherStudentWorkspace:studentFilter:change",function(e,eventData){
        var filteredList = eventData.list||[];
        updateMapItems(filteredList, eventData.selectedStudent);
      });

      eventManager.listen('module:change:meta', function(e, slug) {
        eventManager.broadcast("close:current:module",slug);
      });

      eventManager.listen('destroy-c3-run-like-math-map', function(){
        PIXI_Load_Cache = false;
        window.removeEventListener("resize", onResize);
      });

      scope.$on('$destroy', function() {
        canvas_el.parentNode.removeChild(canvas_el);
        PIXI_Load_Cache = false;
        window.removeEventListener("resize", onResize);
      }.bind(this));

      function onResize(sidepanel_expanded){
        //var canvas_el =  document.getElementById('canvas');
        if (!canvas_el || !canvas_el.parentElement || !canvas_el.parentElement.parentElement || !canvas_el.parentElement.parentElement.parentElement) {
          return;
        }

        var sidepanel_width = 0;
        if(sidepanel_expanded === true || sidepanel_expanded === false){
          sidepanel_width = sidepanel_expanded ? 140:-200;
        }

        canvasDimention = {
          width: canvas_el.parentElement.parentElement.parentElement.clientWidth - sidepanel_width,
          height: canvas_el.parentElement.parentElement.parentElement.clientHeight
        }

        canvas_el.width = canvasDimention.width;
        canvas_el.height = canvasDimention.height;

        renderer.resize(canvasDimention.width, canvasDimention.height);
        if(stage && renderer){
          var scale = Math.min(0.8, renderer.width/880)
          stage.scale.set(scale, scale);
          stage.x = renderer.width / 2  - stage.width/2 - 80;
          if(canvasDimention.width > 500){
            stage.x -= 40;
          }
          stage.y = renderer.height / 2 - stage.height/2;
        }

        renderer.render(stage);
      }
      eventManager.listen('sidepanel:toggled', function(e, val){
        if(!PlatformService.isPhonePortrait()){
          onResize(val);
        }
      })



    }
  }
});

var PIXI_Load_Cache;
var EXISTS;
